import React from "react"
import styled from "styled-components"

import { when, eq, minWidth, maxWidth } from "utils"

import Icon from "icons"
import SectionHeading from "components/section-heading"

export { Slider, Slide } from "pure-react-carousel"

export const Container = styled.section`
  padding: 4.7rem 10.7rem 6.4rem 10.7rem;
  border-width: 0.1rem 0;
  border-style: solid;
  border-color: #222;
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};

  ${minWidth.mobile`
    border: none;
  `}

  ${maxWidth.desktop`
    padding: 4.7rem 5rem 6.4rem 5rem;
  `}

  ${maxWidth.tablet`
    padding: 4.7rem 2rem 3.6rem 2rem;
  `}

  ${maxWidth.mobile`
    padding: 3rem 2rem 3.6rem 1rem;
  `}

  ${when("hide")`
    display: none;
  `}
`

export const HeadingDesktop = styled(SectionHeading)`
  display: none;

  ${minWidth.mobile`
    display: block;
  `}
`

const HeadingMobileWrapper = styled.div`
  ${minWidth.mobile`
    display: none;
  `}
`

const HeadingMobileTitle = styled.div`
  width: fit-content;
  margin: 0 auto;
  padding: 0.5rem 6rem;
  border: 0.1rem solid #db663b;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.3rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  color: #db663b;
`

const HeadingMobileSubtitle = styled.div`
  font-size: 2.2rem;
  font-weight: 500;
  line-height: 3rem;
  text-align: center;
  color: #222;
`

export const HeadingMobile = ({ title, subtitle }) => (
  <HeadingMobileWrapper>
    <HeadingMobileTitle>{title}</HeadingMobileTitle>
    <HeadingMobileSubtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
  </HeadingMobileWrapper>
)

export const List = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > :nth-child(1) {
    flex: 0 0 70%;

    ${maxWidth.desktopL`
      flex: 0 0 60%;
    `}

    ${maxWidth.tablet`
      margin-bottom: 2.8rem;
      flex: 0 0 100%;
    `}
  }

  > :nth-child(2) {
    flex: 0 0 25%;

    ${maxWidth.desktopL`
      flex: 0 0 35%;
    `}

    ${maxWidth.tablet`
      flex: 0 0 100%;
    `}
  }
`

export const TableOfContentsDesktop = styled.div`
  display: none;

  ${minWidth.mobile`
    display: block;
  `}
`

export const VideoMetaDesktop = styled.div`
  margin-bottom: 2.8rem;
  padding: 0 1rem;
  border-left: 0.5rem solid #bbb;
  cursor: pointer;

  ${when("active")`
    border-left-color: #222;
  `}

  :hover {
    border-left-color: #222;
  }

  h3 {
    font-size: 2.4rem;
    font-weight: 500;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.9rem;
  }
`

export const TableOfContentsMobile = styled.div`
  position: relative;
  width: 100%;

  ${minWidth.mobile`
    display: none;
  `}
`

const ScrollLabel = styled.div`
  font-size: 1.6rem;
  line-height: 2.2rem;
`

const ScrollArrowLine = styled(Icon)`
  margin-bottom: 1.2rem;

  ${minWidth.mobile`
    display: none;
  `}
`

export const Scroll = ({ count }) => (
  <>
    <ScrollLabel>Related Videos ({count})</ScrollLabel>
    <ScrollArrowLine viewBox="0 0 345 12" id="horizontal-scroll-arrow" />
  </>
)

export const ScrollContainer = styled.div`
  width: 100%;
`

export const ScrollableGrid = styled.div`
  display: -webkit-box;
  overflow-x: auto;
`

export const VideoMetaMobile = styled.div`
  width: 13.4rem;
  margin-right: 0.4rem;
  margin-left: 0.4rem;

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.2rem;
  }
`

export const VideoImage = styled.div`
  width: 100%;
  height: 7.5rem;
  margin-bottom: 1rem;
  background-color: ${({ active }) => (active ? "#222" : "#ccc")};

  ${when("active")`
    :after {
      content: "Playing";
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.6rem;
      font-weight: 500;
      line-height: 2.2rem;
      color: #fff;
    }
  `}

  ${eq("active", false)`
    background-image: ${({ url }) => `url(${url})`};
    background-size: contain;
  `}
`
